import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { LuUserRoundCheck } from 'react-icons/lu';

import ButtonGroup from 'components/button/ButtonGroup';
import ErrorLayout from 'components/error/ErrorLayout';
import BaseModal from 'components/modal/BaseModal';

import usePageNavigate from 'hooks/common/usePageNavigate';
import useModal from 'hooks/components/useModal';
import useUserInfoWithdrawal from 'hooks/console/userInfo/useUserInfoWithdrawal';
import useHeader from 'hooks/menu/useHeader';

import { text } from 'styles/commons/text';

const NoJWTErrorContent = ({ code, children }) => {
  const { onNavClick } = usePageNavigate();
  const { onLoginBtnClick } = useHeader();
  const { resetLogout } = useUserInfoWithdrawal();
  const { visibleModal, openModal, closeModal } = useModal();

  useEffect(() => {
    openModal('noJWT', '토큰 만료');
    resetLogout('noJWT');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
      {ReactDOM.createPortal(
        <BaseModal visible={visibleModal.isopen}>
          <ErrorLayout
            icon={<LuUserRoundCheck />}
            title={
              <>
                {code === '7807'
                  ? '로그인 유지 시간이 만료되어'
                  : '로그인 인증 정보가 만료되어'}
                <br />
                자동으로 <text.Span color="primary">로그아웃</text.Span>{' '}
                되었습니다.
              </>
            }
            desc={[
              code === '7807' && (
                <>
                  개인 정보 보호를 위해{' '}
                  <text.Span color="primaryDark">24시간</text.Span> 경과 시
                  자동으로 로그아웃됩니다.
                </>
              ),
              <>
                로그인이 필요할 경우{' '}
                <text.Span color="primaryDark" weight="500">
                  '다시 로그인'
                </text.Span>
                버튼을 눌러주세요.
              </>,
            ]}
            button={
              <ButtonGroup
                button={[
                  {
                    text: '메인으로',
                    variant: 'dark-outline',
                    size: 'big',
                    onClick: () => {
                      closeModal();
                      onNavClick('/');
                    },
                    gtm: {
                      url: '/',
                      id: `no-jwt-error-main-modal-btn`,
                    },
                  },
                  {
                    text: '다시 로그인',
                    variant: 'primary',
                    size: 'big',
                    onClick: () => {
                      closeModal();
                      onLoginBtnClick();
                    },
                    gtm: {
                      url: '/login',
                      id: `no-jwt-error-login-modal-btn`,
                    },
                  },
                ]}
              />
            }
          />
        </BaseModal>,
        document.body
      )}
    </>
  );
};

export default NoJWTErrorContent;
